const PrivateRouteConst = {
  USER_VIEW: 'allUserView',
  USER_EDIT: 'allUserEdit',
  USER_DELETE: 'allUserDelete',
  SELF_USER_VIEW: 'selfUserView',
  SELF_USER_EDIT: 'selfUserEdit',
  SELF_USER_DELETE: 'selfUserDelete',
  CREATE_USER: 'createUser',
  USER_BULK_UPLOAD: 'userBulkUpload',
  ORGANISATION_VIEW: 'allOrganizationView',
  ORGANISATION_EDIT: 'allOrganizationEdit',
  ORGANISATION_DELETE: 'allOrganizationDelete',
  SELF_ORGANISATION_VIEW: 'selfOrganizationView',
  SELF_ORGANISATION_EDIT: 'selfOrganizationEdit',
  SELF_ORGANISATION_DELETE: 'selfOrganizationDelete',
  CREATE_ORGANISATION: 'createOrganization',
  ROLE_VIEW: 'allRoleView',
  ROLE_EDIT: 'allRoleEdit',
  ROLE_DELETE: 'allRoleDelete',
  SELF_ROLE_VIEW: 'selfRoleView',
  SELF_ROLE_EDIT: 'selfRoleEdit',
  SELF_ROLE_DELETE: 'selfRoleDelete',
  CREATE_ROLE: 'createRole',
  INCENTIVE_VIEW: 'allIncentiveView',
  INCENTIVE_EDIT: 'allIncentiveEdit',
  INCENTIVE_DELETE: 'allIncentiveDelete',
  SELF_INCENTIVE_VIEW: 'selfIncentiveView',
  SELF_INCENTIVE_EDIT: 'selfIncentiveEdit',
  SELF_INCENTIVE_DELETE: 'selfIncentiveDelete',
  CREATE_INCENTIVE: 'createIncentive',
  PERMISSION_VIEW: 'allManagePermissionView',
  PERMISSION_EDIT: 'allManagePermissionEdit',
  PERMISSION_DELETE: 'allManagePermissionDelete',
  SELF_PERMISSION_VIEW: 'selfManagePermissionView',
  SELF_PERMISSION_EDIT: 'selfManagePermissionEdit',
  SELF_PERMISSION_DELETE: 'selfManagePermissionDelete',
  CREATE_PERMISSION: 'createManagePermission',
  ATTRIBUTE_VIEW: 'allAttributeView',
  ATTRIBUTE_EDIT: 'allAttributeEdit',
  ATTRIBUTE_DELETE: 'allAttributeDelete',
  SELF_ATTRIBUTE_VIEW: 'selfAttributeView',
  SELF_ATTRIBUTE_EDIT: 'selfAttributeEdit',
  SELF_ATTRIBUTE_DELETE: 'selfAttributeDelete',
  CREATE_ATTRIBUTE: 'createAttribute',
  NUDGE_CONFIGURATION_VIEW: 'nudgeConfigurationView',
  NUDGE_CONFIGURATION_CREATE: 'createNudgeConfiguration',
  NUDGE_CONFIGURATION_EDIT: 'nudgeConfigurationEdit',
  NUDGE_CONFIGURATION_DELETE: 'nudgeConfigurationDelete',
  SELF_NUDGE_CONFIGURATION_VIEW: 'selfNudgeConfigurationView',
  SELF_NUDGE_CONFIGURATION_EDIT: 'selfNudgeConfigurationEdit',
  SELF_NUDGE_CONFIGURATION_DELETE: 'selfNudgeConfigurationDelete',

  TEMPLATE_VIEW: 'templateView',
  TEMPLATE_EDIT: 'templateEdit',
  TEMPLATE_DELETE: 'templateDelete',
  TEMPLATE_CREATE: 'createTemplate',
  SELF_TEMPLATE_VIEW: 'selfTemplateView',
  SELF_TEMPLATE_EDIT: 'selfTemplateEdit',
  SELF_TEMPLATE_DELETE: 'selfTemplateDelete',
  AUDIENCE_GROUP_VIEW: 'audienceGroupView',
  AUDIENCE_GROUP_EDIT: 'audienceGroupEdit',
  AUDIENCE_GROUP_DELETE: 'audienceGroupDelete',
  AUDIENCE_GROUP_CREATE: 'createAudienceGroup',
  SELF_AUDIENCE_GROUP_VIEW: 'selfAudienceGroupView',
  SELF_AUDIENCE_GROUP_EDIT: 'selfAudienceGroupEdit',
  SELF_AUDIENCE_GROUP_DELETE: 'selfAudienceGroupDelete',
};

export default PrivateRouteConst;
